<template>
    <div id="ContractView">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div class="web-right-sidebar">
            <div class="right-asset-tab-list">
                <ul class="activetabs" id="tabActive">
                    <li v-bind:class="[ activetab === 1 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="activetab=1" >Contract Detail</a></li>
                    <li v-bind:class="[ activetab === 2 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="activetab=2" >Unit</a></li>
                    <li v-bind:class="[ activetab === 4 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="activetab=4" >CPI Rate Configuration</a></li>
                    <li v-if="canListContractDisc" v-bind:class="[ activetab === 5 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="activetab=5" >Contract Discounts</a></li>
                    <li v-bind:class="[ activetab === 6 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="getActivityLog()"> Activity Log </a> </li>
                   </ul>
            </div>
        </div>
        <div id="page-content-wrapper" class="admin-content-area left-asset-detail-section">
            <template v-if="cantAccessPage === true">
                <div class="page-name asset-view-page-name">
                    <div class="page-title">Contract View</div>
                    <div class="btn-groups text-right">
                        <router-link v-if="activetab === 1" title="Edit Asset" class="btn btn-primary"
                                v-bind:to="{name: 'ContractEdit',params:{id:$route.params.id}}">
                                <i class="fp-edit-icon"> </i> Edit
                        </router-link>
                        <button type="submit" class="btn btn-secondary pull-right ml-1" v-on:click.prevent="goPreviousPath" >
                             <i class="fp-back"> </i>    Back
                        </button>

                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content contact-view list-view">
                        <section class="internal-container border-top-table-fl">
                            <template v-if="activetab === 1">
                                <div class="list-sections">
                                    <div class="form-row no-divider">
                                        <div class="col-md-6">
                                            <div class="row form-group">
                                                <label class="col">Agreement:</label>
                                                <span class="col"> {{titleCase(contractData.code)}} </span>
                                            </div>
                                            <div class="row form-group">
                                                <label class="col"> Contract Type: </label>
                                                <span class="col"> {{titleCase(contractData.ctName + " (" + contractData.ctCode + ") ")}} </span>
                                            </div>
                                            <div class="row form-group">
                                                <label class="col"> Location: </label>
                                                <span class="col"> {{titleCase(contractData.locName + " (" + contractData.locCode + ") ")}} </span>
                                            </div>
                                            <!-- <div class="row form-group" v-if="contractData.cbmName">
                                                <label class="col"> Contract Billing Method: </label>
                                                <span class="col"> {{titleCase(contractData.cbmName)}} </span>
                                            </div>
                                            <div class="row form-group" v-else>
                                                <label class="col"> Contract Billing Method:</label>
                                                <span class="col"> - </span>
                                            </div> -->
                                            <div class="row form-group" v-if="contractData.source_document">
                                                <label class="col"> Source: </label>
                                                <span class="col"> {{titleCase(contractData.source_document)}} </span>
                                            </div>
                                            <div class="row form-group" v-else>
                                                <label class="col"> Source: </label>
                                                <span class="col"> - </span>
                                            </div>
                                            <!-- <div class="row form-group">
                                                <label class="col"> CPI Base Index Date: </label>
                                                <span class="col"> {{contractData.erEffectiveDate}} </span>
                                            </div> -->
                                            <div class="row form-group">
                                                <label class="col"> Status: </label>
                                                <span class="col"> {{titleCase(contractData.status)}} </span>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="row form-group">
                                                <label class="col"> Customer Name: </label>
                                                <span class="col"> {{titleCase(contractData.customerName)}} </span>
                                            </div>
                                            <!-- <div class="row form-group">
                                                <label class="col"> Contract Term: </label>
                                                <span class="col"> {{titleCase(contractData.contract_term)}} </span>
                                            </div>
                                            <div class="row form-group">
                                                <label class="col"> Effective Date: </label>
                                                <span class="col"> {{titleCase(contractData.effective_date)}} </span>
                                            </div> -->
                                            <div class="row form-group" v-if="contractData.ccName">
                                                <label class="col"> CPI Code:</label>
                                                <span class="col"> {{titleCase(contractData.ccName + " (" + contractData.ccCode + ") ")}} </span>
                                            </div>
                                            <div class="row form-group" v-else>
                                                <label class="col"> CPI Code: </label>
                                                <span class="col"> {{'NA'}} </span>
                                            </div>
                                            <!-- <div class="row form-group">
                                                <label class="col"> CPI Base Value: </label>
                                                <span class="col"> {{contractData.erBaseValue}} </span>
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-if="activetab === 2">
                                <app-contract-asset-tab></app-contract-asset-tab>
                            </template>
                            <template v-if="activetab === 4">
                                <app-contract-cpi-config-tab></app-contract-cpi-config-tab>
                            </template>
                            <template v-if="activetab === 5">
                                <app-contract-discount-view :contractId="contractId"></app-contract-discount-view>
                            </template>
                            <div id="contract-activity-log" class="list-view" v-show="activetab == 6">
                                <div class="bg-white data-table p-0">
                                    <contract-activity-log-list :activityLogVal="activityLogsTabValue"></contract-activity-log-list>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

// import ContractCPITabView from "@/components/ContractCPITabView";
import ContractAssetTabView from "@/components/ContractAssetTabView";
import ContractCPIRateConfigTabView from "@/components/ContractCpiRateConfigTabView";
import ContractDiscountView from "@/components/ContractDiscountView";
import {commonMixins} from '../mixins/commonMixins';
// Vue.component("app-contract-cpi-tab", ContractCPITabView);
Vue.component("app-contract-asset-tab", ContractAssetTabView);
Vue.component("app-contract-cpi-config-tab", ContractCPIRateConfigTabView);
Vue.component("app-contract-discount-view", ContractDiscountView);


    export default {
        name: "ContractView",
        components: {
            
            ContractActivityLogList: () => import('@/components/ActivityLogList.vue'),
        },
        mixins:[commonMixins],
        metaInfo() {
            return {
                title: (this.contractData.code != "") ? this.contractData.code + " | Contract View | " +process.env.COPYRIGHT_NAME:"Contract View | " +process.env.COPYRIGHT_NAME
            }
        },
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            contractData: [],
            loading:false,
            activetab: 1,
            canListContract:false,
            contractId:0,
            canListContractDisc:false,
            canAddContractDiscount:false,
            activityLogsTabValue:"dontLoadList",
            tabMenuArray:[],
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'view_contract') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'list_contract_discount') {
                            self.canListContractDisc = true;
                        }
                        if (permissions[i].name == 'add_contract_discount') {
                            self.canAddContractDiscount = true;
                        }
                    }
                }

            }
        },
        created: function() {
        },
        beforeRouteLeave(to, from, next) {
            var self = this;
            self.left_view_edit_channel(from.fullPath);
            next();
        },
        mounted: function() {
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            self.contractId = segments[3];

            self.loadContractViewData();
            self.getPermissions();

            //Join ViewEdit Channel
            self.join_view_edit_channel(segments[1],segments[2],segments[3]);
        },
        methods: {

            handleClick(newTab) {

                var self = this;
                self.currentTab = newTab;
            },

            selectTab(flag){

                alert("You are select " + flag);

            },

            loadContractViewData() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/contract/" + segments[3],
                    type: "GET",
                    headers: this.ajxHeaders,
                    data:{
                        action_flag : 'view', // pass action for notify: view, edit
                        is_notify_flag : true // notify if user viewing or editing
                    },
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            // console.log(data)
                            self.contractData = data.content;
                            var storeObject={visited_page: {
                                    path : "contract |" +data.content.code,
                                    data : window.location.pathname,
                                    }};
                            self.getRecentlyPagesMethod(storeObject);

                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'contract-view-data')
                    }
                });
            },
            titleCase(str) {
                if (str == null){
                    return;
                } else{
                    var value = str.toString()
                    return value.charAt(0).toUpperCase() + value.slice(1)
                }
            },
            formatString(data) {
                if (data == null){
                    return;
                }else {

                    var self = this;
                    var value = data.replace(/_/g, " ");
                    var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                        return letter.toUpperCase();
                    });
                    return upp;
                }
            },
            getActivityLog(){
              var self = this;
              self.activetab = 6;
              var path = window.location.pathname;
              var segments = path.split("/");
              if(!self.tabMenuArray.includes(self.activetab)){

                this.$root.$emit('activity_log_opted','contract',segments[3]);
                self.activityLogsTabValue = "loadList";   // flag value set to loadList so that filters in list work properly.
              }
            },
        }
    };
</script>

<style scoped>


/* RESET */
* {
  box-sizing: border-box;
  margin: 10;
  padding: 10;
}



</style>



// WEBPACK FOOTER //
// src/components/ContractView.vue